import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@core/services/auth.service";
import { DeviceService } from "@core/services/device.service";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class PwaAuthGuardService {
  constructor(
    private readonly authService: AuthService,
    private readonly deviceService: DeviceService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isPwa = this.deviceService.isPwa();

    if (!isPwa) {
      return of(true);
    }

    return this.authService.isAuthenticated$().pipe(
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          const currentUrl = state.url;
          // Store the redirect URL in the router service's navigation
          void this.router.navigate(["/account/login"], {
            queryParams: currentUrl && currentUrl !== "/" ? { redirectUrl: currentUrl } : {}
          });
        }
      }),
      map(isAuthenticated => isAuthenticated)
    );
  }
}
